"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApostilleTransaction = exports.AnnounceType = void 0;
const symbol_sdk_1 = require("symbol-sdk");
const hash_1 = require("../utils/hash");
const MetadataKeyHelper_1 = require("../utils/MetadataKeyHelper");
const ApostilleAccount_1 = require("./ApostilleAccount");
var AnnounceType;
(function (AnnounceType) {
    AnnounceType[AnnounceType["CompleteWithApostilleAccountSign"] = 0] = "CompleteWithApostilleAccountSign";
    AnnounceType[AnnounceType["CompleteWithoutApostilleAccountSing"] = 1] = "CompleteWithoutApostilleAccountSing";
    AnnounceType[AnnounceType["BondedWithApostilleAccountSing"] = 2] = "BondedWithApostilleAccountSing";
    AnnounceType[AnnounceType["BondedWithoutApostilleAccountSing"] = 3] = "BondedWithoutApostilleAccountSing";
    AnnounceType[AnnounceType["CannotAnnounce"] = 4] = "CannotAnnounce";
    AnnounceType[AnnounceType["Unknown"] = 5] = "Unknown";
})(AnnounceType = exports.AnnounceType || (exports.AnnounceType = {}));
class ApostilleTransaction {
    constructor(signerAccount, apostilleAccount, apostilleMessage, networkType, generationHashSeed, feeMultiplier, epochAdjustment, options) {
        this.signerAccount = signerAccount;
        this.apostilleAccount = apostilleAccount;
        this.apostilleMessage = apostilleMessage;
        this.networkType = networkType;
        this.generationHashSeed = generationHashSeed;
        this.feeMultiplier = feeMultiplier;
        this.epochAdjustment = epochAdjustment;
        this.options = options;
        this.createCoreTransaction();
        this.createAssignOwnershipTransaction();
        this.createMetadataTransactions();
    }
    static createFromData(data, hashingType, seed, singerAccount, networkType, generationHashSeed, feeMultiplier, apiEndpoint, epochAdjustment, options) {
        const hashFunc = hash_1.HashFunctionCreator.create(hashingType);
        const apostilleMessage = hashFunc.createApostilleTransactionMessage(data, singerAccount);
        const apostilleAccount = ApostilleAccount_1.ApostilleAccount.create(seed, singerAccount, apiEndpoint);
        const apostilleTransaction = new ApostilleTransaction(singerAccount, apostilleAccount, apostilleMessage, networkType, generationHashSeed, feeMultiplier, epochAdjustment, options);
        return apostilleTransaction;
    }
    static createFromHashedData(hashedData, hashingType, seed, signerAccount, networkType, generationHashSeed, feeMultiplier, apiEndpoint, epochAdjustment, options) {
        const hashFunc = hash_1.HashFunctionCreator.create(hashingType);
        const apostilleMessage = hashFunc.createApostilleTransactionMessageFromHashedData(hashedData, signerAccount);
        const apostilleAccount = ApostilleAccount_1.ApostilleAccount.create(seed, signerAccount, apiEndpoint);
        const apostilleTransaction = new ApostilleTransaction(signerAccount, apostilleAccount, apostilleMessage, networkType, generationHashSeed, feeMultiplier, epochAdjustment, options);
        return apostilleTransaction;
    }
    static updateFromData(data, hashingType, signerAccount, existApostilleAccount, networkType, generationHashSeed, feeMultiplier, apiEndpoint, epochAdjustment) {
        const hashFunc = hash_1.HashFunctionCreator.create(hashingType);
        const apostilleMessage = hashFunc.createApostilleTransactionMessage(data, signerAccount);
        const apostilleAccount = ApostilleAccount_1.ApostilleAccount.createFromExistAccount(existApostilleAccount, apiEndpoint);
        const apostilleTransaction = new ApostilleTransaction(signerAccount, apostilleAccount, apostilleMessage, networkType, generationHashSeed, feeMultiplier, epochAdjustment);
        return apostilleTransaction;
    }
    static updateFromHashedData(hashedData, hashingType, signerAccount, existApostilleAccount, networkType, generationHashSeed, feeMultiplier, apiEndpoint, epochAdjustment) {
        const hashFunc = hash_1.HashFunctionCreator.create(hashingType);
        const apostilleMessage = hashFunc.createApostilleTransactionMessageFromHashedData(hashedData, signerAccount);
        const apostilleAccount = ApostilleAccount_1.ApostilleAccount.createFromExistAccount(existApostilleAccount, apiEndpoint);
        const apostilleTransaction = new ApostilleTransaction(signerAccount, apostilleAccount, apostilleMessage, networkType, generationHashSeed, feeMultiplier, epochAdjustment);
        return apostilleTransaction;
    }
    singedTransactionAndAnnounceType() {
        return __awaiter(this, void 0, void 0, function* () {
            const innerTxs = this.convertInnerTransactions();
            const aggregateTx = yield this.createAggregateTransaction(innerTxs);
            const signedTx = this.signTransaction(aggregateTx);
            const shouldUseHashLockTx = this.shouldUseHashLockTransaction();
            const announceInfo = {
                signedTransaction: signedTx,
                shouldUseHashLockTransaction: shouldUseHashLockTx
            };
            return announceInfo;
        });
    }
    shouldUseHashLockTransaction() {
        switch (this.announceType) {
            case AnnounceType.BondedWithApostilleAccountSing:
            case AnnounceType.BondedWithoutApostilleAccountSing:
                return true;
            default:
                return false;
        }
    }
    createCoreTransaction() {
        const tx = symbol_sdk_1.TransferTransaction.create(symbol_sdk_1.Deadline.create(this.epochAdjustment), this.apostilleAccount.publicAccount.address, [], symbol_sdk_1.PlainMessage.create(this.apostilleMessage), this.networkType);
        this.coreTransaction = tx;
    }
    createAssignOwnershipTransaction() {
        if (this.options && this.options.assignOwners) {
            let approvalNum = 0;
            if (this.options.assignOwners.length <= 2) {
                approvalNum = this.options.assignOwners.length;
            }
            else {
                approvalNum = this.options.assignOwners.length - 1;
            }
            const tx = symbol_sdk_1.MultisigAccountModificationTransaction.create(symbol_sdk_1.Deadline.create(this.epochAdjustment), approvalNum, approvalNum, this.options.assignOwners, [], this.networkType);
            this.assignOwnerShipTransaction = tx;
        }
    }
    createMetadataTransactions() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.options && this.options.metadata) {
                const txs = [];
                Object.entries(this.options.metadata).forEach(([k, v]) => {
                    const tx = symbol_sdk_1.AccountMetadataTransaction.create(symbol_sdk_1.Deadline.create(this.epochAdjustment), this.apostilleAccount.publicAccount.address, MetadataKeyHelper_1.MetadataKeyHelper.keyToKeyId(k), v.length, v, this.networkType);
                    txs.push(tx);
                });
                this.metaDataTransactions = txs;
            }
        });
    }
    convertInnerTransactions() {
        const innerTxs = [];
        if (this.coreTransaction) {
            const innerTx = this.coreTransaction.toAggregate(this.signerAccount.publicAccount);
            innerTxs.push(innerTx);
        }
        if (this.assignOwnerShipTransaction) {
            const innerTx = this.assignOwnerShipTransaction.toAggregate(this.apostilleAccount.publicAccount);
            innerTxs.push(innerTx);
        }
        if (this.metaDataTransactions) {
            this.metaDataTransactions.forEach((tx) => {
                const innerTx = tx.toAggregate(this.apostilleAccount.publicAccount);
                innerTxs.push(innerTx);
            });
        }
        return innerTxs;
    }
    createAggregateTransaction(innerTxs) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setAnnounceType();
            switch (this.announceType) {
                case AnnounceType.CompleteWithApostilleAccountSign:
                case AnnounceType.CompleteWithoutApostilleAccountSing:
                    return this.createCompleteTransaction(innerTxs);
                case AnnounceType.BondedWithApostilleAccountSing:
                case AnnounceType.BondedWithoutApostilleAccountSing:
                    return this.createBondedTransaction(innerTxs);
                default:
                    throw Error('Can not create aggregate transaction');
            }
        });
    }
    createCompleteTransaction(innerTxs) {
        const signerCount = this.getSignerCount();
        const tx = symbol_sdk_1.AggregateTransaction.createComplete(symbol_sdk_1.Deadline.create(this.epochAdjustment), innerTxs, this.networkType, []).setMaxFeeForAggregate(this.feeMultiplier, signerCount);
        return tx;
    }
    createBondedTransaction(innerTxs) {
        const singerCount = this.getSignerCount();
        const tx = symbol_sdk_1.AggregateTransaction.createBonded(symbol_sdk_1.Deadline.create(this.epochAdjustment), innerTxs, this.networkType, []).setMaxFeeForAggregate(this.feeMultiplier, singerCount);
        return tx;
    }
    signTransaction(aggregateTx) {
        switch (this.announceType) {
            case AnnounceType.CompleteWithApostilleAccountSign:
            case AnnounceType.BondedWithApostilleAccountSing:
                return this.signTransactionWithApostilleAccount(aggregateTx);
            case AnnounceType.CompleteWithoutApostilleAccountSing:
            case AnnounceType.BondedWithoutApostilleAccountSing:
                return this.signTransactionWithoutApostilleAccount(aggregateTx);
            default:
                throw Error('Can not sign transaction');
        }
    }
    signTransactionWithApostilleAccount(aggregateTx) {
        if (this.apostilleAccount.account) {
            const signedTx = this.signerAccount.signTransactionWithCosignatories(aggregateTx, [this.apostilleAccount.account], this.generationHashSeed);
            return signedTx;
        }
        throw Error('Can not sign transaction');
    }
    signTransactionWithoutApostilleAccount(aggregateTx) {
        const signedTx = this.signerAccount.sign(aggregateTx, this.generationHashSeed);
        return signedTx;
    }
    getSignerCount() {
        if (this.announceType === AnnounceType.CompleteWithoutApostilleAccountSing) {
            return 1;
        }
        if (this.announceType === AnnounceType.CompleteWithApostilleAccountSign) {
            return 2;
        }
        if (this.announceType === AnnounceType.BondedWithApostilleAccountSing &&
            this.options && this.options.assignOwners) {
            return 2 + this.options.assignOwners.length;
        }
        if (this.announceType === AnnounceType.BondedWithoutApostilleAccountSing) {
            return this.apostilleAccount.multisigInfo.minApproval;
        }
        throw Error('Can not announce transaction');
    }
    setAnnounceType() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apostilleAccount.getMultisigAccountInfo();
            if (this.apostilleAccount.multisigInfo) {
                const { multisigInfo } = this.apostilleAccount;
                if (multisigInfo.minApproval >= 2) {
                    this.announceType = AnnounceType.BondedWithoutApostilleAccountSing;
                    return;
                }
                if (multisigInfo.minApproval === 1 &&
                    multisigInfo.hasCosigner(this.signerAccount.address)) {
                    this.announceType = AnnounceType.CompleteWithoutApostilleAccountSing;
                    return;
                }
                if (multisigInfo.minApproval === 1 &&
                    !multisigInfo.hasCosigner(this.signerAccount.address)) {
                    this.announceType = AnnounceType.CannotAnnounce;
                    return;
                }
            }
            if (this.options && this.options.assignOwners) {
                if (this.options.assignOwners.length === 1 &&
                    this.options.assignOwners.includes(this.signerAccount.address)) {
                    this.announceType = AnnounceType.CompleteWithApostilleAccountSign;
                    return;
                }
                this.announceType = AnnounceType.BondedWithApostilleAccountSing;
                return;
            }
            if (this.metaDataTransactions) {
                this.announceType = AnnounceType.CompleteWithApostilleAccountSign;
                return;
            }
            this.announceType = AnnounceType.CompleteWithoutApostilleAccountSing;
        });
    }
}
exports.ApostilleTransaction = ApostilleTransaction;
//# sourceMappingURL=ApostilleTransaction.js.map